import React from 'react';
import { styles } from './ShowcaseCard.css';
import { ContentfulImageProps } from '../ContentfulImage/ContentfulImage';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import ArrowRightIcon from '@jbhi-fi/lanyard-ui/components/Icons/ArrowRight';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type ShowcaseCardProps = {
  heading: string;
  subText?: string;
  image?: React.ReactElement<ContentfulImageProps>;
  url?: string;
  openInNewWindow: boolean;
  className?: string;
  backgroundColor?: string;
  textColor?: string;
};

export const ShowcaseCard = ({
  heading,
  subText,
  image,
  url,
  openInNewWindow,
  className,
  backgroundColor,
  textColor,
}: ShowcaseCardProps) => {
  const isMobile = !useBreakpoint('md', 'up');
  const textStyle = textColor ? { color: textColor } : undefined;

  const content = (
    <div className={styles.cardWrapper}>
      <div
        className={styles.backgroundLayer}
        style={{ backgroundColor: backgroundColor ? backgroundColor : undefined }}
      >
        <div className={styles.backgroundOverlay} />
      </div>
      <div className={classNames([styles.ShowcaseCardContent, className])}>
        {image ? <div className={styles.imageWrapper}>{image}</div> : null}

        <h3 className={styles.heading} style={textStyle}>
          {heading}
        </h3>
        {subText ? (
          <p className={styles.subText} style={textStyle}>
            {isMobile && subText.length > 122 ? `${subText.slice(0, 122)}...` : subText}
          </p>
        ) : null}
        {isMobile && url ? (
          <Button
            classes={styles.showcaseCardLink}
            onClick={() =>
              openInNewWindow ? window.open(url, '_blank', 'noopener,noreferrer') : (window.location.href = url)
            }
            type="linkWithIcon"
            label="View"
            icon={<ArrowRightIcon />}
          />
        ) : null}
      </div>
    </div>
  );

  const Wrapper: React.ElementType = url && !isMobile ? 'a' : 'div';
  const wrapperProps =
    url && !isMobile
      ? {
          href: url,
          target: openInNewWindow ? '_blank' : '_self',
          rel: openInNewWindow ? 'noopener noreferrer' : undefined,
        }
      : {};
  return (
    <Wrapper className={styles.ShowcaseCard} {...wrapperProps}>
      {content}
    </Wrapper>
  );
};
